import { Checkbox, FormControlLabel } from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { useDataFormatterHook } from "../../../hooks/useDataFormatterHook";
import InputSelect from "../InputSelect";

function CheckSelect({
  name,
  disabled,
  onChange,
  requestValue,
  requestText,
  requestPath,
  requestValues,
  defaultValue = -1,
}) {
  const [value, setValue] = useState(defaultValue);
  const handleValueChanged = useCallback(
    (item) => {
      setValue(item);
      if (onChange instanceof Function) onChange(item);
    },
    [onChange]
  );

  const [enabled, setEnabled] = useState(false);
  const handleEnabledChanged = useCallback(
    (event) => {
      setEnabled(event.target.checked);
      if (!event.target.checked) handleValueChanged(defaultValue);
    },
    [handleValueChanged, defaultValue]
  );

  const { values } = useDataFormatterHook({
    addEmpty: true,
    value: requestValue,
    text: requestText,
    path: requestPath,
    emptyValue: defaultValue,
    defaultValue: requestValues,
  });

  return (
    <div className="flex gap-1">
      <FormControlLabel
        disabled={disabled}
        className="w-20"
        control={
          <Checkbox
            checked={enabled}
            onChange={handleEnabledChanged}
            color="primary"
          />
        }
        label={name}
      />

      <InputSelect
        disabled={disabled || !enabled}
        variant="outlined"
        size="small"
        label={name}
        name="name"
        data={values}
        className="flex-1"
        startValue={value}
        placeholder="DataFormatter"
        setSelectValue={handleValueChanged}
      />
    </div>
  );
}

export default CheckSelect;
